// extracted by mini-css-extract-plugin
module.exports = {"Register":"Register_Register__3UcLk","FormHolder":"Register_FormHolder__1anvo","Action":"Register_Action__ESUb9"};